export default function($injector) {
	return function(input, filters) {
		const _ = $injector.get('_');
		return _.filter(input, (obj) => {
			return _.some(filters, obj.status);
		});
	}
}
